<template>
    <div class="tsa-paySuccess">
        <div class="top-result card">
            <img src="../../assets/images/buy/paySuccess_icon.png" alt="">
            <div class="text">
                <p>充值成功</p>
                <p>您购买的<span>{{ tsCount || 0 }}</span>个时间戳已入账 </p>
            </div>
        </div>
        <div class="bottom-info">
            <div class="item card" v-if="result.rechargeCompleteTwo">
                <div class="item-content">
                    <p class="title">{{ result.rechargeCompleteTwo.name }}</p>
                    <div class="content">
                        <img @click="action(result.rechargeCompleteTwo)" :src="result.rechargeCompleteTwo.imageUrl" alt="">
                    </div>
                </div>
            </div>
            <div class="item card" v-if="result.rechargeCompleteThree">
                <div class="item-content">
                    <p class="title">{{ result.rechargeCompleteThree.name }}</p>
                    <div class="content">
                        <img @click="action(result.rechargeCompleteThree)" :src="result.rechargeCompleteThree.imageUrl" alt="">
                    </div>
                </div>
            </div>
            <div class="leftAndRight card">
                <div class="leftAndRight-content" v-if="result.rechargeCompleteFourLeft">
                    <p class="title">{{ result.rechargeCompleteFourLeft.name }}</p>
                    <div class="content">
                        <div class="left" v-if="result.rechargeCompleteFourLeft">
                            <img @click="action(result.rechargeCompleteFourLeft)" :src="result.rechargeCompleteFourLeft.imageUrl" alt="">
                        </div>
                        <div class="line"></div>
                        <div class="right">
                            <img v-if="result.rechargeCompleteFourRight" @click="action(result.rechargeCompleteFourRight)" :src="result.rechargeCompleteFourRight.imageUrl" alt="">
                        </div>
                    </div>
                </div>
                <div class="functionActions-container" v-if="result.rechargeCompleteFunction || result.rechargeCompleteFunctionTwo || result.rechargeCompleteFunctionThree || result.rechargeCompleteFunctionFour || result.rechargeCompleteFunctionFive || result.rechargeCompleteFunctionSix || result.rechargeCompleteFunctionSeven">
                    <div class="functionActions">
                        <div class="item" @click="action(result.rechargeCompleteFunction)" v-if="result.rechargeCompleteFunction" :style="{ 'background-image': `url(${result.rechargeCompleteFunction.imageUrl})` }"></div>
                        <div class="item" @click="action(result.rechargeCompleteFunctionTwo)" v-if="result.rechargeCompleteFunctionTwo" :style="{ 'background-image': `url(${result.rechargeCompleteFunctionTwo.imageUrl})` }"></div>
                        <div class="item" @click="action(result.rechargeCompleteFunctionThree)" v-if="result.rechargeCompleteFunctionThree" :style="{ 'background-image': `url(${result.rechargeCompleteFunctionThree.imageUrl})` }"></div>
                        <div class="item" @click="action(result.rechargeCompleteFunctionFour)" v-if="result.rechargeCompleteFunctionFour" :style="{ 'background-image': `url(${result.rechargeCompleteFunctionFour.imageUrl})` }"></div>
                        <div class="item" @click="action(result.rechargeCompleteFunctionFive)" v-if="result.rechargeCompleteFunctionFive" :style="{ 'background-image': `url(${result.rechargeCompleteFunctionFive.imageUrl})` }"></div>
                        <div class="item" @click="action(result.rechargeCompleteFunctionSix)" v-if="result.rechargeCompleteFunctionSix" :style="{ 'background-image': `url(${result.rechargeCompleteFunctionSix.imageUrl})` }"></div>
                        <div class="item" @click="action(result.rechargeCompleteFunctionSeven)" v-if="result.rechargeCompleteFunctionSeven" :style="{ 'background-image': `url(${result.rechargeCompleteFunctionSeven.imageUrl})` }"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getAdBannerApi } from "@http/website/index"
import { GetRequest, allSettled } from "@/utils/utils"
import { getDetailByOrderId } from "@http/overview/index";
export default {
    data () {
        return {
            tsCount: 0,
            result: {}
        }
    },
    mounted () {
        // 获取订单id
        getDetailByOrderId({
            orderId: GetRequest().orderId
        }).then(( {status, tsCount }) => {
            // 已支付的订单设置
            if (status === 1) {
                this.tsCount = tsCount
            } else {
                // 已取消和待支付
                this.$router.replace({
                    path: '/Home',
                })
            }
        }).catch((error) => {
            console.error(error)
            this.$router.replace({
                path: '/Home',
            })
        })
        // 支付完成-二屏 rechargeCompleteTwo // 支付完成-三屏
        const promises1 = []
        promises1.push(getAdBannerApi({locations: 12}), getAdBannerApi({locations: 13}))
        allSettled(promises1).then((result) => {
            result.map(item => {
                if (item.status === 'fulfilled') {
                    let value = item.value || {}
                    let key = Object.keys(value)[0]
                    if (key) {
                        this.$set(this.result, key, value[key])
                    }
                }
            })
        })
        
        // 支付完成-四屏-左 //支付完成-四屏-右
        const promises2 = []
        promises2.push(getAdBannerApi({locations: 14}), getAdBannerApi({locations: 15}))
        allSettled(promises2).then((result) => {
            result.map(item => {
                if (item.status === 'fulfilled') {
                    let value = item.value || {}
                    let key = Object.keys(value)[0]
                    if (key) {
                        this.$set(this.result, key, value[key])
                    }
                }
            })
        })

        // 充值完成-产品功能入口-1 // 充值完成-产品功能入口-2 // 充值完成-产品功能入口-3 // 充值完成-产品功能入口-4
        const promises3 = []
        promises3.push(getAdBannerApi({locations: 16}), getAdBannerApi({locations: 17}), getAdBannerApi({locations: 18}), getAdBannerApi({locations: 19}))
        allSettled(promises3).then((result) => {
            result.map(item => {
                if (item.status === 'fulfilled') {
                    let value = item.value || {}
                    let key = Object.keys(value)[0]
                    if (key) {
                        this.$set(this.result, key, value[key])
                    }
                }
            })
        })

        // 充值完成-产品功能入口-5 // 充值完成-产品功能入口-6 // 充值完成-产品功能入口-7
        const promises4 = []
        promises4.push(getAdBannerApi({locations: 20}), getAdBannerApi({locations: 21}), getAdBannerApi({locations: 22}))
        allSettled(promises4).then((result) => {
            result.map(item => {
                if (item.status === 'fulfilled') {
                    let value = item.value || {}
                    let key = Object.keys(value)[0]
                    if (key) {
                        this.$set(this.result, key, value[key])
                    }
                }
            })
        })
    },
    methods: {
        action (item) {
            let traceName = '用户中心_弹窗广告位'
            let traceMap = {
                '广告位名称': item.name,
                '页面名称': '充值成功'
            }
            // 当前页面跳转 1是当前页面 0是新开页面
            if (item.openType === 1) {
                zhuge.track(traceName, traceMap, () => {
                    window.location.href = item.hrefUrl
                })
            } else {
                zhuge.track(traceName, traceMap)
                window.open(item.hrefUrl, '_blank')
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-paySuccess {
        * {
            box-sizing: border-box;
        }
        background: #F7F9FD;
        padding-right: 15px;
        .card {
            background: #FFFFFF;
            border-radius: 20px;
        }
        .top-result {
            width: 100%;
            padding: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 24px;
            img {
                width: 88px;
                height: 88px;
                // margin-top: 20px;
                margin-right: 10px;
            }
            .text {
                margin-top: -15px;
                p {
                    color: #333333;
                    font-size: 14px;
                    span {
                        color: #FF3B00;
                    }
                }
            }
            
        }
        .bottom-info {
            width: 100%;
            >.item {
                display: flex;
                justify-content: center;
                padding: 16px 24px;
                margin-bottom: 24px;
                .item-content {
                    width: 1134px;
                }
                .title {
                    position: relative;
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    word-break: break-all;
                    margin-bottom: 16px;
                    padding-left: 12px;
                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 2px;
                        height: 12px;
                        background: #0047FF;
                    }
                }
                .content {
                    img {
                        width: 100%;
                        height: auto;
                        cursor: pointer;
                        transition: all 0.3s;
                        border-radius: 16px;
                        &:hover {
                            transform: scale(1.01);
                        }
                    }
                }
                
            }
            .leftAndRight {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 16px 24px;
                margin-bottom: 16px;
                .leftAndRight-content {
                    width: 1134px;
                    .title {
                        position: relative;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        word-break: break-all;
                        margin-bottom: 16px;
                        padding-left: 12px;
                        &::after {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 2px;
                            height: 12px;
                            background: #0047FF;
                        }
                    }
                    .content {
                        display: flex;
                        justify-content: space-around;
                        margin-bottom: 16px;
                        img {
                            width: 100%;
                            cursor: pointer;
                            transition: all 0.3s;
                            border-radius: 16px;
                            &:hover {
                                transform: scale(1.01);
                            }
                        }
                        .left {
                            flex: 1;
                        }
                        .line {
                            width: 16px;
                            height: 1px;
                        }
                        .right {
                            flex: 1;
                        }
                    }
                }
                .functionActions-container {
                    width: 1134px;
                    .functionActions {
                        display: flex;
                        .item {
                            flex: 1;
                            height: 130px;
                            background-position: center;
                            background-repeat: no-repeat;
                            background-size: cover;
                            margin-right: 16px;
                            cursor: pointer;
                            border-radius: 20px;
                            overflow: hidden;
                            transition: all 0.3s;
                            &:hover {
                                transform: scale(1.04);
                            }
                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
            
        }
    }
</style>